import React from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import { useStyles } from './ButtonPrimaryLightStyles';
import clsx from 'clsx';

interface IButtonPrimaryLight extends ButtonProps {
  loading?: boolean;
  rootBtnClass: string;
  loadingBtnClass: string;
  loadingAnimationClass: string;
}

export const ButtonPrimaryLight: React.FC<IButtonPrimaryLight> = ({
  rootBtnClass,
  loadingBtnClass,
  loadingAnimationClass,
  disabled,
  className,
  loading,
  children,
  ...rest
}: IButtonPrimaryLight): JSX.Element => {
  const classes = useStyles();
  if (loading) {
    return (
      <Button className={clsx(rootBtnClass, className, loadingBtnClass)} {...rest} disabled>
        <div className={loadingAnimationClass}></div>
      </Button>
    );
  } else {
    return (
      <Button className={clsx(rootBtnClass, classes.btnPrimaryLight, className)} disabled={disabled} {...rest}>
        {children}
      </Button>
    );
  }
};

export default ButtonPrimaryLight;
